module.exports = __webpack_public_path__ + "static/01-658957baf2ad56251f81ebcc67cf1054.png";